'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _rx = require('rx');

exports.default = function (trackingPath) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var params = _ref.params;
  var send = _ref.send;
  return function (trackingParams) {
    return _rx.Observable.fromPromise(new Promise(function (resolve) {
      return resolve(send({
        url: trackingPath,
        params: _extends({}, params, { events: trackingParams })
      }));
    }));
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-impression-tracking/build/createRequestStream.js
 ** module id = 45
 ** module chunks = 0
 **/